module.exports = __webpack_public_path__ + "img/jeancarlo.854a3d24.jpg";